import { useQuery } from '@tanstack/react-query';

import client from './client';

import type { QueryClient, UseQueryOptions } from '@tanstack/react-query';

const INSURANCE_FORMS = 'INSURANCE_FORMS';

export const useInsuranceForms = (
  options: Omit<
    UseQueryOptions<Awaited<ReturnType<typeof client.fetchInsuranceForms>>>,
    'queryFn' | 'queryKey'
  > = {},
) => {
  const {
    data,
    status: getInsuranceFormsStatus,
    isLoading: isGetInsuranceFormsLoading,
    isFetching: isGetInsuranceFormsFetching,
  } = useQuery({
    queryKey: [INSURANCE_FORMS],
    queryFn: client.fetchInsuranceForms,
    ...options,
  });

  const insuranceForms = data?.data?.data ?? [];

  return {
    insuranceForms,
    getInsuranceFormsStatus,
    isGetInsuranceFormsLoading,
    isGetInsuranceFormsFetching,
  };
};

export const getInsuranceFormsFromClient = (queryClient: QueryClient) => {
  const insuranceFormsData = queryClient.getQueryData<
    Awaited<ReturnType<typeof client.fetchInsuranceForms>>
  >([INSURANCE_FORMS]);

  return insuranceFormsData?.data?.data ?? [];
};
